<template>
  <div>
    <div class="modal-header">
      <h2>Novi projekat</h2>
    </div>
    <div
      class="body-project"
      :class="[{ 'step-1-height': step == 1 }, { 'step-2-height': step != 1 }]"
    >
      <div class="input-wrapper" v-if="step == 1">
        <label class="col-form-label col-form-label-lg">
          Naziv
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite naziv"
          v-model.trim="name"
        />
        <label class="col-form-label col-form-label-lg">
          Opis
          <span class="mandatory">*</span>
        </label>
        <textarea
          type="text"
          rows="3"
          class="form-control"
          v-model.trim="description"
          placeholder="Unesite opis"
        />
        <!-- <input
          class="form-control"
          rows="4"
          placeholder="Unesite opis"
          v-model.trim="description"
        /> -->
        <label class="col-form-label col-form-label-lg tooltip-label">
          Tip projekta
          <span class="mandatory">*</span>
          <div class="custom-tooltip">
            <i class="fas fa-info-circle"></i>
            <span class="tooltiptext"
              >Trajan podsetnik se može dodati za svaku novu zajednicu koja se
              doda u sistem.</span
            >
          </div>
        </label>

        <select
          class="form-control custom-select"
          id="selecCategory"
          v-model="type"
        >
          <option value="1">Privremen</option>
          <option value="2">Trajan</option>
        </select>
      </div>
      <div class="members-wrapper" v-if="step == 2">
        <div class="members-control">
          <input
            type="text"
            placeholder="Pretraga"
            v-model="searchCriteria"
            class="form-control form-control-lg search-input"
          />
          <button class="btn btn-primary btn-add" @click="selectAll">
            Izaberi sve zajednice
          </button>
          <button class="btn btn-primary btn-add" @click="deselectAll">
            Poništi izbor
          </button>
          <label class="col-form-label col-form-label-lg">
            Serviser
          </label>
          <model-select
            ref="municipality"
            :options="contractors"
            v-model="selectedContractor"
            placeholder="
            Izaberite servisera"
            class="muni-dropdown add-member-dropdown"
            @input="onContractorChange"
          ></model-select>
          <label class="col-form-label col-form-label-lg">
            Kontakt osoba
          </label>
          <model-select
            ref="municipality"
            :options="contractorContacts"
            v-model="selectedContact"
            placeholder="
            Izaberite kontakt osobu"
            class="muni-dropdown add-member-dropdown"
            @input="onContractorContactChange"
          ></model-select>
        </div>
        <div class="members">
          <mini-table
            :columns="communityColumns"
            :data="getFilteredCommunities"
            :height="420"
            :checkable="true"
          ></mini-table>
          <div class="total-wrapper">
            Izabrano {{ numOfSelected }}/{{ allCommunities.length }}
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="footer">
      <transition enter-active-class="animated shake">
        <p class="error" v-if="errorMessage.length > 0">{{ errorMessage }}</p>
      </transition>
      <div class="screen1" v-if="step == 1">
        <div class="buttons">
          <button
            type="submit"
            class="btn btn-danger btn--mod"
            @click="closeModal"
          >
            Otkaži
          </button>
          <button
            type="submit"
            class="btn btn-primary btn--mod"
            @click="goToStep2"
          >
            Dalje
          </button>
        </div>
      </div>
      <div class="screen2" v-if="step == 2">
        <div class="buttons buttons-step-2">
          <button
            type="submit"
            class="btn btn-danger btn--mod"
            @click="closeModal"
            :disabled="loading"
          >
            Otkaži
          </button>
          <button
            type="submit"
            class="btn btn--mod btn-default"
            @click="step--"
            :disabled="loading"
          >
            Nazad
          </button>
          <button
            type="submit"
            class="btn btn-primary btn--mod"
            @click="saveReminder"
            :disabled="loading"
          >
            <p v-if="!loading">Sačuvaj</p>
            <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import miniTable from '../ModalFinancesTable';
import axios from '@/axios/axios.js';
import { ModelSelect } from 'vue-search-select';

export default {
  components: {
    miniTable,
    ModelSelect
  },
  data() {
    return {
      step: 1,
      searchCriteria: '',
      errorMessage: '',
      name: '',
      description: '',
      type: '1',
      communityColumns: [{ key: 'name', label: 'Stambena zajednica', flex: 1 }],
      allCommunities: [],
      loading: false,
      contractors: [],
      selectedContractor: null,
      contractorContacts: [],
      selectedContact: null
    };
  },
  async created() {
    const contractorsResult = await this.getAllContractors(false);
    this.contractors = contractorsResult.map(cat => {
      cat.value = cat;
      cat.text = cat.name;
      return {
        value: cat,
        text: cat.name
      };
    });
    for (const comm of this.$store.getters.getCommunitiesImploded) {
      this.allCommunities.push({
        name: comm.name,
        checked: false,
        id: comm.id
      });
    }
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('table', ['getAllProjects', 'getAllContractors']),
    validateStep1() {
      if (this.name == '') {
        this.errorMessage = 'Morate uneti naziv projekta';
        return false;
      }
      if (this.description == '') {
        this.errorMessage = 'Morate uneti opis projekta';
        return false;
      }
      return true;
    },
    goToStep2() {
      this.errorMessage = '';
      if (!this.validateStep1()) {
        return;
      }
      this.step = 2;
    },
    deselectAll() {
      for (const comm of this.allCommunities) {
        comm.checked = false;
      }
    },
    selectAll() {
      for (const comm of this.getFilteredCommunities) {
        comm.checked = true;
      }
    },
    validateStep2() {
      if (this.getFilteredCommunities.filter(c => c.checked).length == 0) {
        this.errorMessage = 'Morate izabrati bar jednu zajednicu';
        return false;
      }
      return true;
    },
    onContractorContactChange(data) {
      if (data) {
        const contractor = this.contractorContactsAllData.find(
          c => c.id == data
        );
      }
    },
    async onContractorChange() {
      try {
        if (
          this.selectedContractor &&
          (this.selectedContractor.id || this.selectedContractor.value.id)
        ) {
          let contractorId = null;
          if (this.selectedContractor.id) {
            contractorId = this.selectedContractor.id;
          } else {
            contractorId = this.selectedContractor.value.id;
          }
          const result = await axios.get(`/contractor/${contractorId}`);
          this.contractorContactsAllData = result.data.contractor.contacts;
          this.contractorContacts = result.data.contractor.contacts.map(con => {
            return {
              text: `${con.name} (${con.phone})`,
              value: con.id
            };
          });
        } else {
          this.selectedContractor = null;
          this.sendToContractor = false;
          this.selectedContact = null;
        }
      } catch (error) {
        this.selectedContractor = null;
        this.sendToContractor = false;
        this.selectedContact = null;
      }
    },
    async saveReminder() {
      if (!this.validateStep2()) {
        return;
      }
      this.loading = true;
      const reminderData = {
        title: this.name,
        description: this.description,
        type: this.type
      };
      try {
        const addProjectResponse = await axios.post('project', reminderData);
        try {
          //
          const communityIds = this.getFilteredCommunities
            .filter(c => c.checked)
            .map(c => c.id);
          let contractorId = null;
          if (this.selectedContractor) {
            if (this.selectedContractor.value) {
              contractorId = this.selectedContractor.value.id;
            } else {
              contractorId = this.selectedContractor.id;
            }
          }
          const addCommunitiesData = {
            communityIds: communityIds,
            contractorId: contractorId,
            contractorContactId: this.selectedContact
          };
          await axios.post(
            `project/${addProjectResponse.data.projectId}/addCommunity`,
            addCommunitiesData
          );
          try {
            await this.getAllProjects();
          } catch (error) {
            console.log(error);
            // refresh page if auto refresh fails so we get latest projects
            this.$router.go();
          }
          this.showSuccessModal();
          this.closeModal();
        } catch (error) {
          console.log(error);
          this.loading = false;
          this.showFailModal(
            'Projekat je kreiran ali zajednice nisu dodate. Molimo Vas da ih dodate iz detalja projekta.'
          );
          try {
            await this.getAllProjects();
          } catch (error) {
            console.log(error);
            // refresh page if auto refresh fails so we get latest projects
            this.$router.go();
          }
          this.closeModal();
        }
      } catch (error) {
        this.loading = false;
        this.showFailModal();
      }
    }
  },
  computed: {
    getFilteredCommunities() {
      if (this.searchCriteria === '') {
        return this.allCommunities;
      } else {
        return this.allCommunities.filter(c => {
          if (
            c.name.toLowerCase().includes(this.searchCriteria.toLowerCase())
          ) {
            return this.allCommunities;
          }
        });
      }
    },
    numOfSelected() {
      let num = 0;
      for (let c of this.allCommunities) {
        if (c.checked) {
          num++;
        }
      }
      return num;
    }
  }
};
</script>
<style lang="scss" scoped>
.buttons {
  float: right;
  .btn-danger:disabled {
    border: none;
  }
  .btn--mod {
    height: 35px;
    min-width: 75px;
    margin-left: 5px;
    margin-right: 4px;
    align-self: center;
  }
  .btn-default {
    background-color: #d9d9d9 !important;
    color: black;
  }

  button {
    position: relative;
  }

  button:disabled {
    background-color: var(--primary-color-lighten);
  }
}
.error {
  color: red;
  float: left;
  margin: 0 auto;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  p {
    margin: 0;
  }
}
.tooltip-label {
  display: flex;
}
.step-1-height {
  height: 45vh;
}
.step-2-height {
  height: 62vh;
}
.body-project {
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  // min-height: 430px;
  // height: 430px;

  .input-wrapper {
    height: 100%;
    // display: flex;
    width: 100%;
    padding: 1rem 0.2rem;
    textarea {
      resize: none;
    }

    .expenses-input-wrapper {
      padding-right: 1rem;
      margin-right: 1rem;
      border-right: 1px solid #e9ecef;
      height: 100%;
      width: 55%;

      .input-fields {
        display: flex;
        align-items: center;
        padding-left: 1.5px;
        div:not(:last-child) {
          margin-right: 0.7rem;
        }

        .field-name {
          flex: 1;
          position: relative;
          .input--name:focus ~ .input.span--name,
          .input--name:not(:placeholder-shown) ~ .input-span--name {
            transform: scale(0.75) translateY(-50px) translateX(-30px);
          }
        }

        .field-amount {
          flex: 1;
          position: relative;
          .input--amount:focus ~ .input.span--amount,
          .input--amount:not(:placeholder-shown) ~ .input-span--amount {
            transform: scale(0.75) translateY(-50px) translateX(-30px);
          }
        }

        .field-price {
          flex: 1;
          position: relative;
          .input--price:focus ~ .input.span--price,
          .input--price:not(:placeholder-shown) ~ .input-span--price {
            transform: scale(0.75) translateY(-50px) translateX(-30px);
          }
        }
      }

      .input-span {
        position: absolute;
        font-size: 1.3rem;
        color: rgb(95, 95, 95);
        top: 0.6rem;
        left: 1rem;
        pointer-events: none;
        transition: 0.2s all;
      }

      .btn--add {
        margin: 1rem 0;
        width: 100%;
        font-size: 1.2rem;
      }

      .btn--add:active,
      .btn--add:focus {
        box-shadow: none !important;
      }

      .predefined-expenses {
        max-height: 15rem;
        min-height: 10rem;
        height: calc(100% - 126px);
        width: 100%;
      }
    }
  }
  .expenses-preview {
    width: 45%;
    position: relative;
  }

  .members-wrapper {
    height: 100%;
    display: flex;

    .members-control {
      width: 40%;
      padding-right: 1rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      margin-right: 1rem;
      border-right: 1px solid #e9ecef;
      padding-left: 2px;
      .search-input {
        width: 100%;
        // height: 70px;
        border: none;
        border-radius: 0;
        margin-bottom: 1rem;
        -webkit-transition: 0.5s border-bottom;
        transition: 0.5s border-bottom;
        background-color: #eeeeee;
        box-shadow: none;
        border-bottom: 2px solid transparent;
      }

      .search-input:focus {
        border-color: var(--primary-color);
        box-shadow: none;
      }

      button {
        margin-bottom: 1rem;
      }
    }

    .members {
      width: 60%;
      position: relative;
    }
  }
  .total-wrapper {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 1.2rem;
    font-weight: 900;
  }

  .border-red {
    border-color: red !important;
  }
}
</style>
